import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/AppContext"

export default function AvatarChatsList( { array, mobile, handleSelectedAvatar, selectedAvatar } ) {

    //CONTEXT
    const { capitalizeWords } = useContext( AppContext )

    //STATE
    const [ visible, setVisible ] = useState( true )

    //EFFECTS
    useEffect(() => {
        if (selectedAvatar){
            setVisible( false )
        } else {
            setVisible( true )
        }
    }, [ selectedAvatar ])

    return(
        <div className={ ''}>  
            <h4 onClick={() => setVisible( true )} className="mobile list-header">{ selectedAvatar ? `Chat with ${selectedAvatar.name}`: 'Select an avatar to start chatting:'}</h4>
            <h4 onClick={() => setVisible( true )} className="desktop list-header">{ selectedAvatar ? 'Chat with another avatar' : 'Select an avatar to start chatting:'}</h4>
            <ul className={`${ !visible ? 'hidden': ''}`}>
                <>
                { array.map(( item, idx ) => {

                    const avatar = item.data

                        return(
                            <li className="avatar-chat-preview-card " key={ idx } onClick={() => handleSelectedAvatar( avatar )}>
                                <p>{`${capitalizeWords( avatar.name )} - ${capitalizeWords( avatar.occupation )}`}</p>
                                <p>{`${capitalizeWords( avatar.companyName )} - ${capitalizeWords( avatar.campaignName )}`}</p>
                            </li>
                        )
                    })
                }
                </>
            </ul>
        </div>
    )
}